import { LanguageInfo } from '@unistocks/proxy/axios-client';
import { getLocales } from 'expo-localization';

/**
 * Get the device locale
 */
export const getDeviceLocale = (): string => {
  const locales = getLocales();
  const prefferedLocale = locales[0].languageTag;

  return prefferedLocale;
};

/**
 * Get the language from the device locale if it is supported
 * @param languages The list of supported languages
 */
export const getDeviceLanguage = (languages?: LanguageInfo[]) => {
  const getShortLocale = (locale: string) => locale.split('-')[0]?.toLowerCase();

  // Get language from device settings
  const deviceLocale = getDeviceLocale()?.toLowerCase();
  const deviceLocaleShort = getShortLocale(deviceLocale).toLowerCase();

  if (languages?.length) {
    // Check if the language is supported
    const deviceLang =
      languages.find(l => l.cultureName && l.cultureName.toLowerCase() === deviceLocale) ||
      languages.find(l => l.cultureName && getShortLocale(l.cultureName) === deviceLocaleShort);

    if (deviceLang) return deviceLang;
  }

  return {
    cultureName: deviceLocaleShort ?? deviceLocale
  } as LanguageInfo;
};
